<template>
  <epc-modal-wrapper :active.sync="isActive" :title="$t('select_gantt_capture')" :width="720">
    <div v-if="captures.length" class="grid grid-cols-2 sm:grid-cols-3 gap-3">
      <div v-for="(c, i) in captures" :key="i"
        class="cursor-pointer border border-gray-200 rounded-lg overflow-hidden hover:border-blue-light"
        @click="select(c)">
        <img :src="c.url" :alt="$t('gantt_capture')" style="height: 120px; width: 100%; object-fit: cover;" />
        <p class="text-center text-sm text-gray-600 py-1">{{ c.date }}</p>
      </div>
    </div>
    <div v-else class="text-center text-gray-500 py-6">{{ $t('no_gantt_captures') }}</div>
  </epc-modal-wrapper>
</template>

<script>
// Modal para elegir una captura del Gantt. Solo presentación: el acceso a datos (IndexedDB)
// y el envoltorio blob→File viven en el servicio `loadGanttCaptures`; aquí solo mostramos las
// miniaturas (object URLs) y emitimos la elegida con { name, image(File) }.
import EpcModalWrapper from '·/components/epc-modal-wrapper.vue'
import { loadGanttCaptures } from '../services/detailed-report.service.js'

export default {
  name: 'gantt-captures-modal',

  components: { EpcModalWrapper },

  props: {
    projectId: { type: [Number, String], default: null },
  },

  data() {
    return { isActive: false, captures: [] }
  },

  methods: {
    async show() {
      this.revoke()
      const items = await loadGanttCaptures(this.projectId)
      // Solo creamos los object URLs para las miniaturas (recurso de presentación).
      this.captures = items.map((c) => ({ ...c, url: URL.createObjectURL(c.file) }))
      this.isActive = true
    },

    hide() {
      this.isActive = false
      this.revoke()
      this.captures = []
    },

    select(c) {
      this.$emit('select', { name: 'Gantt ' + c.date, image: c.file })
      this.hide()
    },

    // Libera los object URLs creados para las miniaturas.
    revoke() {
      this.captures.forEach((c) => { if (c.url) URL.revokeObjectURL(c.url) })
    },
  },

  beforeDestroy() {
    this.revoke()
  },
}
</script>
